import { render, staticRenderFns } from "./SMSVerification.vue?vue&type=template&id=25f07f2e&scoped=true"
import script from "./SMSVerification.vue?vue&type=script&lang=js"
export * from "./SMSVerification.vue?vue&type=script&lang=js"
import style0 from "./SMSVerification.vue?vue&type=style&index=0&id=25f07f2e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25f07f2e",
  null
  
)

export default component.exports